import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { CountryDataForm, defaultCountryDataForm } from '../../../app/models/Country';
import useCountryService from '../../../app/services/hooks/useCountryService';
import CountryForm from './forms/CountryForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const CountryCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [country, setCountry] = useState<CountryDataForm>(defaultCountryDataForm);
    const [errorFields, setErrorFields] = useState<any>();
    const { storeCountry, fetchingStoreCountry } = useCountryService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando país...');
        storeCountry(country, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
                if (onError) onError();
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <CountryForm country={country} setCountry={setCountry} errorFields={errorFields} />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={() => onCancel?.()} locked={fetchingStoreCountry} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreCountry} />
                </div>
            </div>
        </>
    );
};

export default CountryCreate;
